import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-chevron-right',
  standalone: true,
  templateUrl: './rt-icon-chevron-right.component.html',
  styleUrls: ['./rt-icon-chevron-right.component.scss']
})
export class RtIconChevronRightComponent {
  @Input() width: number | string = 5;
  @Input() height: number | string = 9;
}
